export const AVATARS = [
  '👤',
  '🦊',
  '👽',
  '🤖',
  '🐸',
  '🐼',
  '👻',
  '🐯',
  '🦁',
  '🐮',
  '🐷',
  '🐵',
  '🐝',
  '🐞',
  '🦀',
  '🐠',
  '🌞',
  '🌚',
  '🌍',
  '🌈',
  '⚡',
  '🔥',
  '💧',
  '✨',
];

export const TIMEZONES = [
  'Auto',
  'UTC',
  'US/Pacific',
  'US/Mountain',
  'US/Central',
  'US/Eastern',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Australia/Sydney',
];

export const appId = 'project-project-30249';

export const APPROVED_EMAILS = [
  'hermessthurston@gmail.com',
  'juliecohen@gmail.com',
  'brettgaddyav@gmail.com',
  'tom.gutowski@gmail.com',
  'aegaddy@gmail.com',
  'ilan.cortes@gmail.com',
  'nbshif@gmail.com',
  'brett.gaddy@gmail.com',
  'adam.lein88@gmail.com',
  'macncheese52@gmail.com',
  'softska@gmail.com',
];

export const MUTED_COLORS = [
  { id: 'default', hex: '#ffffff' },
  { id: 'red', hex: '#fecaca' },
  { id: 'orange', hex: '#fed7aa' },
  { id: 'yellow', hex: '#fef08a' },
  { id: 'green', hex: '#bbf7d0' },
  { id: 'blue', hex: '#bfdbfe' },
  { id: 'purple', hex: '#ddd6fe' },
  { id: 'pink', hex: '#fbcfe8' },
];

export const version = '1.2.3';
export const CLIENT_VERSION = 10;
export const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // M16: idle → forced-refresh gate. Single source of truth; change here.

export const TMDB_API_KEY = '4752dbadd39b5990a9760826d692d669';
export const TMDB_READ_ACCESS_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0NzUyZGJhZGQzOWI1OTkwYTk3NjA4MjZkNjkyZDY2OSIsIm5iZiI6MTc1NDk4MTI4Mi41MTcsInN1YiI6IjY4OWFlM2EyNWNmNjExZjVmNmM2ZmNjMyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.4E0dOliX-0RIsQxn6KBXuLuF1ASF4-wmNtFzYnooLGU';

export const TAG_HIERARCHY = {
  'Want to Go': {},
  'Food': {
    'Asian': {
      'Thai': {},
      'Malaysian': {
        'Roti Canai': {}
      }
    },
    'Burger': {
      'Smashburger': {}
    },
    'Pizza': {},
    'Tacos': {},
    'Russian Food': {},
    'Donut': {}
  },
  'Drinks': {
    'Beer': {
      'Lambic/Sour': {},
      'Takeaway (Beer)': {}
    },
    'Wine': {
      'Takeaway (Wine)': {}
    },
    'Cocktails': {},
    'Tiki': {},
    'Rum': {},
    'Liquor Store': {},
    'Beer Store': {}
  },
  'Coffee': {},
  'Sights': {
    'Museum': {},
    'Park': {},
    'Architecture': {},
    'Music Venues': {}
  }
};

// Helper function to extract all tags from the hierarchy
const extractTags = (hierarchy) => {
  let tags = [];
  for (const [key, children] of Object.entries(hierarchy)) {
    tags.push(key);
    if (Object.keys(children).length > 0) {
      tags = tags.concat(extractTags(children));
    }
  }
  return tags;
};

export const AVAILABLE_TAGS = extractTags(TAG_HIERARCHY);

// Helper function to get all parent tags for a given tag
export const getParentTags = (targetTag, hierarchy = TAG_HIERARCHY) => {
  const search = (node, path) => {
    for (const [key, children] of Object.entries(node)) {
      if (path.includes(key)) continue;
      if (key === targetTag) return path;
      if (Object.keys(children).length > 0) {
        const result = search(children, [...path, key]);
        if (result) return result;
      }
    }
    return null;
  };
  return search(hierarchy, []) || [];
};

// Helper function to get all child tags for a given tag
export const getChildTags = (targetTag, hierarchy = TAG_HIERARCHY) => {
  let foundNode = null;
  
  const findNode = (node, target) => {
    for (const [key, children] of Object.entries(node)) {
      if (key === target) {
        foundNode = children;
        return true;
      }
      if (findNode(children, target)) return true;
    }
    return false;
  };
  
  findNode(hierarchy, targetTag);
  
  if (!foundNode) return [];
  return extractTags(foundNode);
};

export const MOBILE_SECTION_IDS = ['weather', 'todayEvents', 'habits', 'myTasks', 'projects', 'internetRadio', 'groceries', 'wantToGo', 'toWatch', 'bookmarks', 'pomodoro'];
